import { render, staticRenderFns } from "./budgetResultDetail.vue?vue&type=template&id=deff3796"
import script from "./budgetResultDetail.vue?vue&type=script&lang=js"
export * from "./budgetResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deff3796')) {
      api.createRecord('deff3796', component.options)
    } else {
      api.reload('deff3796', component.options)
    }
    module.hot.accept("./budgetResultDetail.vue?vue&type=template&id=deff3796", function () {
      api.rerender('deff3796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetResultDetail.vue"
export default component.exports